import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgAccount({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 16a5 5 0 015 5 1 1 0 01-2 0 3 3 0 00-3-3H8a3 3 0 00-3 3 1 1 0 01-2 0 5 5 0 015-5h8zM12 2a6 6 0 110 12 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8z"
        fill={color}
      />
    </svg>
  )
}

export default SvgAccount
